import type {
  AuthenticatedReloadPreviewContribution,
  AuthenticatedReloadPreviewRequest,
  ResolvedAuthenticatedReloadPreview,
} from './authenticated-reload-preview-types.ts';

interface ReloadPreviewModule {
  default: AuthenticatedReloadPreviewContribution;
}

const previewModules = import.meta.glob(
  '../../plugins/**/p-*/offer-to-authenticated-reload-preview.tsx',
  { eager: true },
);

const previews = Object.values(previewModules).map(
  (module) => (module as ReloadPreviewModule).default,
);

export function resolveAuthenticatedReloadPreview(
  request: AuthenticatedReloadPreviewRequest,
): ResolvedAuthenticatedReloadPreview | null {
  for (const preview of previews) {
    const content = preview.render(request);
    if (content) return { content, id: preview.id };
  }
  return null;
}

export function authenticatedReloadPreview(
  request: AuthenticatedReloadPreviewRequest,
): ReturnType<AuthenticatedReloadPreviewContribution['render']> {
  return resolveAuthenticatedReloadPreview(request)?.content ?? null;
}
